import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { Provider } from 'react-redux';
import routes from './routes';
import createStore from './store/store';
import { analytics } from './utils/analytics';
import { getSharedAppInsights } from './utils/applicationInsights_configuration';
import { loadTheme, initializeIcons } from '@fluentui/react';
import { Provider as TeamsProvider, teamsTheme, mergeThemes } from '@fluentui/react-northstar'
import { svgIconStyles } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconStyles';
import { svgIconVariables } from '@fluentui/react-northstar/dist/es/themes/teams/components/SvgIcon/svgIconVariables';
import * as siteVariables from '@fluentui/react-northstar/dist/es/themes/teams/siteVariables';

// We want to initialize AppInsights as soon as possible so that we catch
// any exceptions thrown during initialization of the page
analytics.initializeAnalytics(getSharedAppInsights());

loadTheme({
  palette: {
    themePrimary: '#5B5FC7',
    themeLighterAlt: '#444791',
    themeLighter: '#444791',
    themeLight: '#444791',
    themeTertiary: '#444791',
    themeSecondary: '#5B5FC7',
    themeDarkAlt: '#4F52B2',
    themeDark: '#444791',
    themeDarker: '#444791',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#c2c2c2',
    neutralSecondary: '#858585',
    neutralPrimaryAlt: '#4b4b4b',
    neutralPrimary: '#333333',
    neutralDark: '#272727',
    black: '#1d1d1d',
    white: '#ffffff',
  },
});
initializeIcons();

const iconTheme = {
  componentStyles: {
    SvgIcon: svgIconStyles
  },
  componentVariables: {
    SvgIcon: svgIconVariables
  },
  siteVariables
};

ReactDOM.render(
  <Provider store={createStore()}>
    <TeamsProvider theme={mergeThemes(iconTheme, teamsTheme)} className="wrapper">
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <BrowserRouter>
        {renderRoutes(routes)}
      </BrowserRouter>
    </TeamsProvider>
  </Provider>,
  document.getElementById('root'),
);
